<script>
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';

    let img;
    let main;
    let img2;
    let content;
    let imgMove;
    let imgMove2;
    let imgMove3;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(
            main,
            img,
            [
                {y: 0, duration: 1},
                {duration: 1, y: '23.364vw', x: '7.009vw'},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            img2,
            [
                {y: 0, duration: 1},
                {duration: 1, y: '-33.14vw', x: '6.908vw'},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            content,
            [
                {y: 0, duration: 1},
                {duration: 1, y: '-18.692vw'},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            imgMove,
            [
                {y: 0, duration: 1},
                {duration: 1, y: 0, x: -115},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            imgMove2,
            [
                {y: 0, duration: 1},
                {duration: 1, y: -5, x: -115},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            imgMove3,
            [
                {duration: 1, x: '175vw'},
                {duration: 1, x: '175vw'},
            ],
            3,
        );
    }
</script>

<div class="main" bind:this={main}>
    <div class="imgWrapper" bind:this={imgMove3}>
        <img
            src="images/featuersMobile/Background.png"
            alt=""
            width="auto"
            height="100%"
        />
    </div>
    <div class="container">
        <div class="title">
            <p>HOW IT WORKS ?</p>
        </div>
        <div class="intro">
            <p>
                Immerse audiences in new<br /> levels of storytelling and<br />
                engagement.
            </p>
        </div>
        <div class="storyBlock" bind:this={img}>
            <div class="storyLeft">
                <p class="p1">Story</p>

                <p class="p2" id="m1">
                    NLP trained to extract features from any <span
                        >literary style</span
                    > in English.
                </p>
                <p class="p3" id="m2">Thereʼs no special syntax to learn.</p>
            </div>
            <div class="storyRight" bind:this={imgMove}>
                <img src="images/featuersMobile/32.png" alt="" />
            </div>
        </div>
        <div class="plusIcon">
            <img src="images/featuersMobile/PLUS.svg" alt="" />
        </div>
        <div class="opusBlock" bind:this={img2}>
            <div class="opusLeft">
                <p class="p1">Opus</p>
                <p class="p2" id="m3">
                    <span id="green">Text to Video</span> generation using AI.
                </p>
                <p class="p3" id="m4">
                    <span id="green">Computational Production</span> - everything
                    from scenes, assets, characters, dialogue and visual effects.
                </p>
            </div>
            <div class="opusRight" bind:this={imgMove2}>
                <img src="images/featuersMobile/52.png" alt="" />
            </div>
        </div>
        <div class="barwrap" bind:this={content}>
            <div class="originalContent">
                <p class="Content">Original Content</p>
            </div>
            <div class="cost">
                <p class="Content">1 / 10th of cost</p>
            </div>
            <div class="unmatchedSpeed">
                <p class="Content">Unmatched Speed</p>
            </div>
        </div>
        <div class="arrow">
            <p>></p>
        </div>
    </div>
</div>

<style>
    .storyBlock {
        margin-top: 9.579vw;
        display: flex;
        margin-left: 10.28vw;
        width: 60.047vw;
        height: 44.393vw;
        border: 1px solid #bebebe;
        transform: translate(0px, 4.673vw);
    }
    .opusBlock {
        margin-top: 3.505vw;
        display: flex;
        margin-left: 10.28vw;
        width: 60.047vw;
        height: 44.393vw;
        border: 1px solid #bebebe;
        transform: translate(0px, -4.673vw);
    }
    .barwrap {
        display: flex;
        /* justify-content: right; */
        flex-direction: column;
        width: 100%;
        align-items: end;
    }
    .main {
        width: 100%;
        position: relative;
        height: max(216.33vw, 100vh);
        overflow: hidden;
    }
    .arrow {
        margin-top: 4.907vw;
        display: flex;
        justify-content: center;
        align-items: center;
        /* margin-bottom: 7.009vw; */
        height: 2.336vw;
        width: 100%;
        /* margin: auto; */
        /* margin-bottom: 7.009vw; */
    }
    .arrow p {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 500;
        font-size: 7.009vw;
        line-height: 8.79vw;
        letter-spacing: 0.06em;
        color: #000000;
        transform: rotate(90deg);
    }

    .Content {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 600;
        font-size: 2.804vw;
        line-height: 3.505vw;
        margin-right: 4.673vw;
        /* identical to box height */

        text-align: right;

        color: #ffffff;
    }
    .originalContent {
        margin-top: 7.505vw;
        /* margin-right: 0; */
        height: 7.058vw;
        width: 76.362vw;
        background-color: #d578ff;
        display: flex;
        align-items: center;
        justify-content: end;
        /* float: right; */
    }
    .cost {
        margin-top: 0.5vw;
        display: flex;
        align-items: center;
        justify-content: end;
        /* float: right; */
        height: 7.058vw;
        width: 70.736vw;
        background-color: #f259a6;
    }
    .unmatchedSpeed {
        margin-top: 0.5vw;
        display: flex;
        align-items: center;
        justify-content: end;
        /* float: right; */
        height: 7.058vw;
        width: 87.617vw;
        background-color: #625df0;
    }
    p {
        margin: 0;
    }
    .p1 {
        width: 10.514vw;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 900;
        font-size: 3.271vw;
        line-height: 4.206vw;
        color: #000000;
        position: relative;
    }
    .p1::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: -3.505vw;
        color: #000000;
        width: 40.187vw;
        border: 1px solid;
        opacity: 0.7;
        margin-top: 3.505vw;
    }
    .p2 {
        width: 44.86vw;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 2.336vw;
        line-height: 3.037vw;

        color: #000000;
    }
    .p2 span {
        color: #f259a6;
    }
    .p3 {
        width: 52.336vw;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 2.336vw;
        line-height: 3.037vw;
        color: #000000;
    }
    .plusIcon {
        margin-top: 3.505vw;
        width: 100%;
        display: flex;
    }
    .plusIcon img {
        margin: auto;
        width: 4.439vw;
        height: 4.439vw;
    }
    .opusLeft {
        padding-left: 5.841vw;
        padding-top: 7.477vw;
    }
    .opusRight {
        margin-top: 5.841vw;
        height: 34.112vw;
        width: 26.402vw;
        border: 2px solid;
        margin-left: 53.505vw;
        position: absolute;
        /* overflow: hidden; */
    }
    .opusRight img {
        height: 100%;
        width: 100%;
    }
    .storyRight img {
        height: 100%;
        width: 100%;
    }
    .storyLeft {
        padding-left: 5.841vw;
        padding-top: 7.477vw;
    }
    .storyRight {
        position: absolute;
        margin-left: 53.505vw;
        height: 34.112vw;
        width: 26.402vw;
        margin-top: 4.673vw;
    }
    .intro {
        width: 100%;
        margin-top: 6.542vw;
    }
    .intro p {
        text-align: center;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 3.037vw;
        line-height: 3.738vw;
        text-align: center;

        color: #000000;
    }
    .title {
        margin-left: 4.907vw;
        width: 93.692vw;
        /* height: 9.346vw; */
    }
    .title p {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 900;
        font-size: 9.346vw;
        line-height: 100%;
        /* identical to box height, or 40px */

        text-transform: uppercase;

        color: #000000;
    }
    .container {
        display: flex;
        flex-direction: column;
        width: 100%;
        /* height: 100%; */
        position: absolute;
        /* margin-top: 36.215vw; */
        top: 35.28vw;
    }
    .imgWrapper {
        position: absolute;
        width: 100%;
        height: max(216.355vw, 100vh);
        transform: rotate(180deg) translateX(-100vw);
    }
    #green {
        color: #46ae00;
    }
    #m1 {
        margin-top: 11.683vw;
        width: 44.86vw;
    }
    #m2 {
        margin-top: 3.271vw;
    }
    #m3 {
        margin-top: 8.178vw;
        width: 43.925vw;
    }
    #m4 {
        width: 43.458vw;
        margin-top: 5.14vw;
    }
</style>
